import { Component, computed, Input, OnInit, signal } from '@angular/core';
import { links } from '../../constants/header';
import { RoutePaths } from '../../constants/routes';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { ButtonComponent } from '../../../shared/ui-component/button/button.component';
import { filter } from 'rxjs';
import { CommonModule, NgClass } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [
    RouterLink,
    ButtonComponent,
    SvgIconComponent,
    RouterLinkActive,
    NgClass,
    CommonModule,
  ],
})
export class HeaderComponent implements OnInit {
  public isMenuOpen = false;
  @Input() isQuestionnaire!: boolean;
  /** When true, show only the logo (with link to home); used e.g. on /partners. */
  @Input() logoOnly = false;

  private transparentRoutes = [
    '/',
    `/${RoutePaths.HOME}`,
    `/${RoutePaths.NEWS}`,
    `/${RoutePaths.CONTACT}`,
    `/${RoutePaths.ESTIMATIONS}`,
  ];
  private transparentPrefixes = [`${RoutePaths.QUESTIONNAIRE}/promotions/`];
  private transparentSig = signal(false);
  isTransparent = computed(() => this.transparentSig());

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        const url = (e.urlAfterRedirects ?? e.url).split('?')[0]; // strip query
        this.handleUrlChange(url);
      });
  }

  ngOnInit(): void {
    // this is done to check the transparent state bcz router event in constructor only runs on route change not on first render
    this.handleUrlChange(this.router.url);
  }

  handleUrlChange(url: string) {
    const isExactMatch = this.transparentRoutes.includes(url);
    const isPrefixMatch = this.transparentPrefixes.some(prefix =>
      url.startsWith(`/${prefix}`)
    );

    this.transparentSig.set(isExactMatch || isPrefixMatch);
  }

  openQuestionnaire() {
    this.router.navigate([`/${RoutePaths.QUESTIONNAIRE}`]);
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  handleMobileLogoClick() {
    this.closeMenu();
    if (!this.router.url.startsWith(`/${RoutePaths.QUESTIONNAIRE}`))
      this.router.navigate([`/${RoutePaths.HOME}`]);
  }

  protected readonly links = links;
  protected readonly RoutePaths = RoutePaths;
}
